import type { ProjectRepository } from '../repository/ProjectRepository';
import type { ProjectCreateCommand, ProjectCreateResponse } from '../entity/ProjectTypes';

export class CreateProjectUseCase {
  constructor(private readonly repository: ProjectRepository) {}

  async execute(command: ProjectCreateCommand): Promise<ProjectCreateResponse> {
    return this.repository.createProject(command);
  }
}


